import { HTMLAttributes } from 'react';
import { CardTitle } from '@/shared/ui/core';


export function AuthCardTitle ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
    return (
        <CardTitle
            as='h1'
            className={ className }
            data-template="auth-card-title"
            { ...props }
        />
    );
}
